import React from 'react';
import { useTranslation } from 'react-i18next';
import ContactUs from '../components/contactUs/ContactUs';
import ServicesComponent from '../components/ServicesComponents/ServicesComponent';
import illustration from '../assests/app.png';

const AppDevelopmentPage = () => {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language?.startsWith('en');
  const benefits = isEnglish
    ? ['A clear plan for your users, features and priorities.', 'Interfaces designed to make everyday tasks easier.', 'Development and improvements based on your requirements.']
    : ['En tydlig plan för användare, funktioner och prioriteringar.', 'Gränssnitt som gör vardagens uppgifter enklare.', 'Utveckling och förbättringar utifrån dina behov.'];

  return (
    <main>
      <ServicesComponent
        img={illustration}
        thead="App Development"
        idName="app-development"
        desc={isEnglish
          ? 'Turn an idea into a useful digital tool. We help you explore, design and develop applications for your customers or your team. Tell us what you want to achieve and we can discuss the right scope, platform and next steps.'
          : 'Gör din idé till ett användbart digitalt verktyg. Vi hjälper dig att utforska, designa och utveckla applikationer för dina kunder eller ditt team. Berätta vad du vill uppnå så diskuterar vi lämplig omfattning, plattform och nästa steg.'}
      >
        <ul className="service-components-benefits">{benefits.map((benefit) => <li key={benefit}>{benefit}</li>)}</ul>
      </ServicesComponent>
      <div id="contact"><ContactUs border defaultService="app-development" /></div>
    </main>
  );
};

export default AppDevelopmentPage;
